import React from 'react'
import { ReactComponent as ErrorImage } from 'App/assets/error-welbe.svg'
import { Container, Content } from './ErrorInfo.styles'

export const ErrorInfo = () => {
	return (
		<Container>
			<Content>
				<ErrorImage />
				<h4>Algo salió mal, intentalo nuevamente</h4>
				<p>Si el error persiste ponte en contacto con soporte.</p>
			</Content>
		</Container>
	)
}
